import React from "react";
import FooterFeature from "./FooterFeature";

const features = [
  {
    id: 1,
    icon: "/icons/lokasyon.svg",
    title: "Benzersiz lokasyonlar",
    description:
      "Villalarımız, plajlara ve popüler turistik noktalara yakın benzersiz konumlarda bulunuyor.",
  },
  {
    id: 2,
    icon: "/icons/ozel_havuzli.svg",
    title: "Özel Havuzlu Villalar",
    description:
      "Özel havuzlu villalarımızda serinleyin, özgürlüğün ve rahatlığın tadını çıkarın. Sadece size ait bir tatili deneyimleyin.",
  },
  {
    id: 3,
    icon: "/icons/customer-satisfaction.svg",
    title: "%100 Müşteri Memnuniyeti",
    description:
      "Tatil beklentilerinizi en üst düzeyde karşılamak için her zaman en iyisini sunmaya çalışıyoruz. Memnuniyetiniz, başarımızın ölçütüdür.",
  },
  {
    id: 4,
    icon: "/icons/destek.svg",
    title: "Uzman Destek Ekibi",
    description:
      "Uzman destek ekibimiz, tatiliniz boyunca ihtiyaç duyduğunuz her an yardıma hazır. Her zaman yanınızdayız ve size destek olmaya hazırız.",
  },
];

const FeatureSection = () => {
  return (
    <div className="lg:mb-[112px] md:mb-14 mb-7">
      <div className="container">
        <div className="grid lg:grid-cols-4 sm:grid-cols-2 grid-cols-1 lg:gap-[90px] md:gap-10 gap-5">
          {features.map((feature) => (
            <FooterFeature
              key={feature.id}
              icon={feature.icon}
              title={feature.title}
              description={feature.description}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default FeatureSection;
